// Define weights for each type of hair extension
var weightsold = {
  "Genius Wefts": { 16: 36, 20: 45, 22: 50, 24: 54 },
  "Keratin Tip": { 16: 15, 20: 17.5, 22: 25 },
  "Handtied Wefts": { 16: 24, 20: 32, 22: 36 },
  "Micro Wefts": { 16: 30, 20: 30, 22: 30, 24: 30 },
  "Volume Wefts": { 16: 120, 20: 145, 22: 160, 24: 175 },
  "I-Tip Extensions": { 16: 15, 20: 17.5, 22: 25 },
};

var weights = {
  "Genius Wefts": {
    16: { weight: 36, handle: "16-genius-weft" },
    20: { weight: 45, handle: "20-genius-weft" },
    22: { weight: 50, handle: "22-genius-weft" },
    24: { weight: 54, handle: "24-genius-weft" },
  },
  "Keratin Tip": {
    16: { weight: 15, handle: "16-inch-keratin-v-tip" },
    20: { weight: 17.5, handle: "kovi-20-keratin-tip-hair-silky-straight" },
    22: { weight: 25, handle: "kovi-22-keratin-tip-hair-silky-straight" },
  },
  "Handtied Wefts": {
    16: { weight: 24, handle: "kovi-silky-straight-16-handtied-wefts" },
    20: { weight: 32, handle: "kovi-silky-straight-20-handtied-wefts" },
    22: { weight: 36, handle: "kovi-silky-straight-22-handtied-wefts" },
  },
  "Micro Wefts": {
    16: { weight: 30, handle: "16-inch-micro-weft" },
    20: { weight: 30, handle: "20-inch-micro-weft" },
    22: { weight: 30, handle: "22-inch-micro-weft" },
    24: { weight: 30, handle: "kovi-24-micro-weft" },
  },
  "Volume Wefts": {
    16: { weight: 120, handle: "kovi-16-volume-weft" },
    20: { weight: 145, handle: "kovi-20-volume-weft" },
    22: { weight: 160, handle: "kovi-22-volume-weft" },
    24: { weight: 175, handle: "kovi-24-volume-weft" },
  },
  "I-Tip Extensions": {
    16: { weight: 15, handle: "kovi-16-i-tip-hair-silky-straight" },
    20: { weight: 17.5, handle: "kovi-20-i-tip-hair-silky-straight" },
    22: { weight: 25, handle: "kovi-22-i-tip-hair-silky-straight-1" },
  },
};

// Call the function to initialise length options
window.onload = function () {
  document
    .getElementById("from-extension")
    .addEventListener("change", updateLengthOptions);
  document
    .getElementById("to-extension")
    .addEventListener("change", checkToExtensionLength);
  updateLengthOptions();
};

function updateLengthOptions() {
  // Get selected extension and length
  var fromExtension = document.getElementById("from-extension").value;
  var selectedLength = document.getElementById("length").value;

  // Get length dropdown
  var lengthDropdown = document.getElementById("length");

  // Clear length dropdown options
  while (lengthDropdown.firstChild) {
    lengthDropdown.removeChild(lengthDropdown.firstChild);
  }

  // Add new options to length dropdown
  var availableLengths = Object.keys(weights[fromExtension]);

  for (var i = 0; i < availableLengths.length; i++) {
    var length = availableLengths[i];
    var option = document.createElement("option");
    option.value = length;
    option.text = length + '"';
    lengthDropdown.appendChild(option);
  }

  // If previously selected length exists, select it
  if (availableLengths.includes(selectedLength)) {
    lengthDropdown.value = selectedLength;
  }
  // If the 'To' extension doesn't have a 24" option, select 22" instead
  else if (!weights[fromExtension]["24"]) {
    lengthDropdown.value = "22";
  }
}

function checkToExtensionLength() {
  // Get selected 'To Extension'
  var toExtension = document.getElementById("to-extension").value;

  // Get length dropdown
  var lengthDropdown = document.getElementById("length");

  // Get selected 'From Extension' length
  var fromLength = lengthDropdown.value;

  // Check if 'To Extension' doesn't have a 24" option and 'From Extension' length is 24"
  if (!weights[toExtension]["24"] && fromLength === "24") {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: 'The selected "Convert To" does not have a 24" option. We have automatically changed the length to 22".',
    });

    // If the 'To Extension' doesn't have a 24" option but has a 22" option, select 22" instead
    if (weights[toExtension]["22"]) {
      lengthDropdown.value = "22";
    }
    // If there's no 22" option either, select the first available length option
    else {
      lengthDropdown.value = Object.keys(weights[toExtension])[0];
    }
  }
}

function calculateConversion() {
  var quantityInput = document.getElementById("quantity");
  var lengthInput = document.getElementById("length");
  var fromExtensionSelect = document.getElementById("from-extension");
  var toExtensionSelect = document.getElementById("to-extension");
  var gramInput = document.getElementById("grams");

  var fromExtension = fromExtensionSelect.value;
  var toExtension = toExtensionSelect.value;
  var length = lengthInput.value;
  var quantity = parseInt(quantityInput.value, 10);
  var grams = parseInt(gramInput.value, 10);

  // Check if 'From Extension' length is 24" and 'To Extension' doesn't have a 24" option
  if (length === "24" && !weights[toExtension]["24"]) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: 'The selected "Convert To" does not have a 24" option. We have automatically changed the length to 22".',
    }).then((result) => {
      // When SweetAlert is dismissed, change the length to '22'
      lengthInput.value = "22";
    });

    return; // Exit the function early
  }

  // Determine whether we're converting by grams or by quantity.
  var isByGrams = document.getElementById("segment-2").checked;

  var fromWeight = weights[fromExtension][length].weight;
  var toWeight;

  var conversion;
  var toExtensionHandle;
  if (isByGrams) {
    // Make sure grams input is valid before proceeding.
    if (isNaN(grams) || grams <= 0) {
      Swal.fire({
        icon: "error",
        title: "Input Error",
        text: "Please enter a valid number of grams.",
      });

      return;
    }
    conversion = grams / weights[toExtension][length].weight;
    toExtensionHandle = weights[toExtension][length].handle;
  } else {
    toWeight = weights[toExtension][length].weight;
    conversion = (fromWeight * quantity) / toWeight;
    toExtensionHandle = weights[toExtension][length].handle;
  }
  if (isNaN(quantity) || quantity <= 0) {
    Swal.fire({
      icon: "error",
      title: "Input Error",
      text: "Please enter a valid quantity.",
    });

    return;
  }
  conversion = Math.ceil(conversion * 10) / 10; // Round up to nearest .1

  var resultString = isByGrams
    ? `You would need ${conversion} packs of ${toExtension} to equal ${grams} grams of ${length}" extensions.`
    : `You would need ${conversion} packs of ${toExtension} to equal ${quantity} pack(s) of ${fromExtension}.`;

  // get the product data from Shopify
  $.ajax({
    url: "/products/" + toExtensionHandle + ".json",
    type: "GET",
    dataType: "json",
    success: function (product) {
      var featuredImage = product.product.images[0].src;
      Swal.fire({
        title: resultString,
        text: toExtension,
        imageUrl: featuredImage,
        imageWidth: 400,
        imageAlt: toExtension,
        showCancelButton: true,
        confirmButtonText: "Go to Product",
        cancelButtonText: "Close",
        reverseButtons: true,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/products/" + toExtensionHandle;
        }
      });
    },
  });
}

function toggleInputType(type) {
  var fromExtensionDropdown = document.getElementById("from-extension");
  var gramInput = document.getElementById("hair-extension-gram-input");
  var quantityLabel = document.getElementById("quantity-label");
  var quantityInput = document.getElementById("quantity");
  var extensionsDescription = document.getElementById("extensions-description");
  var gramsDescription = document.getElementById("grams-description");
  var convertFormInnerContainer = document.getElementById(
    "convert-form-inner-container"
  );

  if (type === "grams") {
    gramInput.style.display = "block";
    fromExtensionDropdown.style.display = "none";
    quantityLabel.style.display = "none";
    quantityInput.style.display = "none";
    extensionsDescription.style.display = "none";
    gramsDescription.style.display = "block";
    convertFormInnerContainer.style.display = "block";
  } else {
    gramInput.style.display = "none";
    fromExtensionDropdown.style.display = "block";
    quantityLabel.style.display = "block";
    quantityInput.style.display = "block";
    extensionsDescription.style.display = "block";
    gramsDescription.style.display = "none";
    convertFormInnerContainer.style.display = "block";
  }

  if (window.innerWidth <= 600) {
    convertFormInnerContainer.scrollIntoView({ behavior: "smooth" });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const faqQuestions = document.querySelectorAll(".faq-question");

  faqQuestions.forEach((faqQuestion) => {
    faqQuestion.addEventListener("click", function () {
      // Close all other dropdowns
      faqQuestions.forEach((otherFaqQuestion) => {
        if (otherFaqQuestion !== this) {
          otherFaqQuestion.classList.remove("active");
          otherFaqQuestion.nextElementSibling.style.maxHeight = null;
        }
      });

      // Toggle the clicked dropdown
      this.classList.toggle("active");
      const faqAnswer = this.nextElementSibling;
      faqAnswer.style.maxHeight = faqAnswer.style.maxHeight
        ? null
        : faqAnswer.scrollHeight + "px";
    });
  });
});
